<template>
    <div :class="{'EnumForm--expanded': isExpanded}">

        <div v-if="legend" class="form__legend d-flex justify-content-between align-items-center" style="cursor: pointer;" @click.prevent="isExpanded = ! isExpanded">
            <span>{{ legend }}</span>
            <i class="fa" :class="isExpanded ? 'fa-minus-square-o' : 'fa-plus-square-o'" aria-hidden="true"></i>
        </div>

        <div v-if="title" href="#" class="EnumForm__trigger" @click.prevent="isExpanded = ! isExpanded">
            <span>{{ title }}</span>
            <i class="fa" :class="isExpanded ? 'fa-minus-square-o' : 'fa-plus-square-o'" aria-hidden="true"></i>
        </div>

        <div class="form__controls--no-label" v-show="isExpanded">
            <label class="form__checkbox"
                v-for="(item, i) in options" :key="i"
            >
                <input type="hidden" :name="`enums[${i}]`" value="0">
                <input type="checkbox" :name="`enums[${i}]`" :value="i" v-model="enums">
                {{ item.title }}
                <EnumFormHelp v-if="item.descr">
                    {{ item.descr }}
                </EnumFormHelp>
            </label>
        </div>

    </div>
</template>

<script>
    import EnumFormHelp from './EnumFormHelp.vue';

    export default {
        components: {
            EnumFormHelp
        },

        props: [
            'legend',
            'title',
            'options',
            'selected'
        ],

        data() {
            return {
                isExpanded: false,
                enums: []
            }
        },

        mounted() {
            this.enums = this.selected
        }
    }
</script>

<style lang="scss">
    .EnumForm__trigger {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5em;
        margin: 0 2rem;
        color: inherit;
        cursor: pointer;
    }

    .EnumForm__trigger:hover,
    .EnumForm--expanded .EnumForm__trigger {
        color: #000;
        border-radius: 2px;
        text-decoration: none;
        background-color: rgba(0,0,0,.1);
    }

    .EnumForm--expanded {
        margin-bottom: 2rem;
    }
</style>
